module.exports = __webpack_public_path__ + "media/images/products/item_preview-410637ea21868263411101410c357ce7.jpg";